<template>
  <div class="acc">
    <h1 class="acc-h1">
      Location Details
    </h1>
    <p class="acc-lead">
      How your venue appears to couples across Breeze: its description, contact details and address.
    </p>

    <location />
  </div>
</template>

<script>
import Location from '@/components/account/Location.vue'

export default {
  name: 'Account',
  components: {
    Location,
  },
}
</script>

<style scoped lang="scss">
@import '~@/design-system/mixins';

.acc {
  max-width: 1140px;
  margin: 0 auto;
  color: $c-text;
}

.acc-h1 {
  @include ds-page-title;
}

.acc-lead {
  @include ds-lead;
}
</style>
